import { TransactionBlock } from '@mysten/sui.js/transactions';
import { SuiClient } from '@mysten/sui.js/client';
export async function signSuiTransaction(params) {
  const {
    signer,
    transaction
  } = params;
  const txBlock = TransactionBlock.from(transaction);
  const client = new SuiClient({
    url: 'https://sui-mainnet.blockvision.org/v1/2o4sVybXFInyr84XlR4U9aLpzP1'
  });
  const bytes = await txBlock.build({
    client
  });
  const serializedSignature = await signer.signTransactionBlock(bytes);
  const signature = serializedSignature.signature;
  return {
    transactionBlock: bytes,
    signature
  };
}